<template>
  <div>
    <div class="mdi-window-manager__root js-window-manager_root">
      <!-- Summary List -->
      <v-layout class="mdi-window-manager__tab-wrapper">
        <div v-for="(tab, index) in tabs" :key="index" class="mdi-window-manager__tab-container elevation-24">
          <v-layout class="fill-height align-center pl-3 pr-2">
            <div class="pr-3">
              <span>{{ tab.title }}</span>
            </div>
            <div class="mdi-window-manager__zoom" @click="onMaximize(tab.uuid)">
              <a class="mdi-window-manager__zoombutton" href="#"></a>
            </div>
          </v-layout>
        </div>
      </v-layout>
      <!-- Real Window -->
      <v-layout class="mdi-window-manager__window-container">
        <div
          v-for="{ uuid, initPos, zIndex, component, options } = bootstrap in windowBootstraps"
          :key="uuid"
          :id="uuid"
          :style="`transform: translate(${initPos.x}px, ${initPos.y}px); z-index: ${zIndex}`"
          @mousedown="onFocus(uuid, $event)"
        >
          <child-window
            ref="TgWindows"
            :windowOptions="options"
            :windowEventBus="windowEventBus"
            :data-window-id="uuid"
            @minimize="onMinimize(uuid, $event)"
          >
            <div :is="component" :eventBus="windowEventBus"></div>
          </child-window>
        </div>
      </v-layout>
    </div>
  </div>
</template>

<script>
// NEED TO BOOK MARK FEATURE.
import uuid from 'uuid/v4';

import ChildWindow from './components/ChildWindow';
import attributeCheckable from './mixins/attribute-checkable';
import { setStyle } from './utils/dom-helper';
import theme from './class/Theme';

function createWindowId() {
  return 'mdi-' + uuid().substring(0, 8);
}

const normalize = (length) => (Number.isInteger(length) ? `${length}px` : length);

export default {
  props: {
    // below prop is for sharing data around all window component
    windowEventBus: Object,
  },
  mixins: [attributeCheckable],
  components: {
    ChildWindow,
  },
  mounted() {
    const { width, height } = this.$attrs;
    const el = this.$el.querySelector('.js-window-manager_root');
    setStyle(el, { width: normalize(width), height: normalize(height) });

    if (this.hasAttribute('light')) theme.change('light');
    else if (this.hasAttribute('dark')) theme.change('dark');
  },
  data() {
    return {
      tabs: [],
      windowBootstraps: [],
      currentZIndex: 0,
    };
  },
  methods: {
    createNewWindow(singleFileComponent) {
      // WARNING: terminate maybe occure bug. becaouse length is changed when terminate(coponent removed)
      this.currentZIndex++;

      // parse component attribute
      const windowOptions = singleFileComponent['mdi-options'] || {};
      const { initPos = {}, labels = {}, mode, collapsable, draggable } = windowOptions;

      const uuid = createWindowId();
      const windowBootstrap = {
        uuid,
        zIndex: this.currentZIndex, //TODO: will be beter. use data-z attribute data-width.
        initPos: {
          x: initPos.x || 20 * this.windowBootstraps.length, // initPos가 없으면 자동으로 할당하는 코드.
          y: initPos.y || 100 * this.windowBootstraps.length,
        },
        options: windowOptions,
        component: singleFileComponent,
      };
      this.windowBootstraps.push(windowBootstrap);
      return uuid;
    },
    reset() {
      this.windowBootstraps = [];
    },
    _findChildWindowRef(uuid) {
      if (!this.$refs.TgWindows) return;
      const i = this.$refs.TgWindows.findIndex((obj) => {
        return obj.$attrs['data-window-id'] === uuid;
      });

      if (i === -1) {
        return null;
      } else {
        return this.$refs.TgWindows[i];
      }
    },

    onFocus(uuid, $event) {
      const bootstrap = this.windowBootstraps.filter((bootstrap) => bootstrap.uuid === uuid)[0];
      this.currentZIndex++;
      bootstrap.zIndex = this.currentZIndex;

      this.$refs.TgWindows.forEach((ref) => {
        ref.enableCurtain(true);
      });

      const ref = this._findChildWindowRef(uuid);
      ref.enableCurtain(false);
    },
    onMinimize(uuid, title) {
      const el = this.$el.querySelector(`#${uuid}`);
      el.style.display = 'none';

      this.tabs.push({
        title,
        uuid,
      });
    },
    onMaximize(uuid) {
      const el = this.$el.querySelector(`#${uuid}`);
      el.style.display = 'block';

      const tab = this.tabs.filter((tab) => tab.uuid === uuid)[0];
      const index = this.tabs.indexOf(tab);
      this.tabs.splice(index, 1);

      this.onFocus(uuid);
    },
  },
  watch: {
    currentZIndex(value) {
      // FIXME: make this currentZIndex shift algorithmS
      if (value === 999) alert('out of window memory');
    },
  },
};
</script>

<style scoped>
/* TODO: can be merged root and container */
.mdi-window-manager__root {
  width: 100%;
  height: 100%;
  --tabs-height: 30px;
  overflow: hidden;
}

.mdi-window-manager__window-container {
  width: 100%;
  height: calc(100% - var(--tabs-height));
}

.mdi-window-manager__tab-wrapper {
  height: var(--tabs-height);
}

.mdi-window-manager__tab-container {
  color: black;
  background-color: #fff;
  background: linear-gradient(to bottom, #e6e6e6, #c4c4c4);
  border-radius: 5px 5px 5px 5px;
  border-bottom: 1px solid #9e9e9e;
  margin: 4px;
  text-transform: capitalize;
}

.mdi-window-manager__zoom {
  background: #00ca56;
  font-size: 9pt;
  line-height: 11px;
  margin-left: 6px;
  width: 11px;
  height: 11px;
  border: 1px solid #14ae46;
  border-radius: 50%;
  display: inline-block;
}

.mdi-window-manager__zoom:active {
  background: #029740;
  border: 1px solid #128435;
}

.mdi-window-manager__zoombutton:active {
  color: #003107;
}

.mdi-window-manager__zoombutton {
  color: #006519;
  visibility: hidden;
  cursor: default;
}
</style>
